import React from 'react';
import NotificationsHeader from './NotificationsHeader';
import NotificationsList from './NotificationsList';
import './notifications.scss';

const Notifications = () => {
  return (
    <div className="notificationpage main-wrapper">
      <div className="container">
        <div className="notificationpage-content">
          <section className="notification-side">
            <div className="notifications">
              <NotificationsHeader />
              <NotificationsList />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Notifications;
